import {
    HTTP,
    HTTP_INTRANET
} from '../http-common'


export default {
    state: {
        list: [],
        total: 0,
        loading: false,
        filters: {},
        contractors: [],
        reserveUpdated: ''        
    },
    mutations: {
        setReserveList(state, payload) {
            state.list = payload
        },
        setTotal(state, payload) {
            state.total = payload
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setFilters(state, payload) {
            state.filters = payload
        },
        setContractors(state, payload) {
            state.contractors = payload
        },
        setReserveUpdated(state, payload) {
            state.reserveUpdated = payload
        },
    },
    actions: {
        getReserveList({
            commit,
        }, f) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                HTTP.post('/reserve/get-reserve-list', f)
                    .then(response => {
                        commit('setLoading', false)
                        if (response.data)  {
                            commit('setReserveList', response.data.content.reserveList)
                            commit('setTotal', response.data.content.total)
                            commit('setReserveUpdated', response.data.content.reserveUpdated)
                            resolve(response.data.content.reserveList)
                        } else {
                            resolve()
                        }
                    })
                    .catch(e => {
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getContractors({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                HTTP.get('/reserve/get-contractors')
                    .then(response => {
                        commit('setLoading', false)
                        if (response.data)  {
                            commit('setContractors', response.data.content.contractors)
                            resolve(response.data.content.contractors)
                        } else {
                            resolve()
                        }
                    })
                    .catch(e => {
                        console.error(e)
                        reject(e)
                    })
            })
        },
        reloadReserve({
        }, f) {
            return new Promise((resolve, reject) => {
                HTTP_INTRANET.post('/reserve', f)
                    .then(response => {
                        if (response.data)  {
                            resolve(response.data)
                        } else {
                            resolve()
                        }
                    })
                    .catch(e => {
                        console.error(e)
                        reject(e)
                    })
            })
        },

   }
}